<script lang="ts">

    import Line from './Line.svelte';
    import Tile, { TileProps } from './Tile.svelte';
    import { storeLanguage, lang_fr, storeNumberEnterprise } from "../scripts/store";
    import { onMount } from "svelte";

    var tile02_fr: TileProps = {
        icon: "../assets/images/tile02.png",
        title: "Réseau",
        text: "Enrichir son réseau avec environ 90 entreprises qui ont les mêmes enjeux que vous autour des APIs",
    };
    var tile02_en: TileProps = {
        icon: "../assets/images/tile02.png",
        title: "Network",
        text: "Enrich your network with approximately 90 companies that have the same challenges as you around APIs",
    }

    onMount(async() => {
        storeNumberEnterprise.subscribe(data => {
            tile02_fr = {
                icon: "../assets/images/tile02.png",
                title: "Réseau",
                text: "Enrichir son réseau avec environ "+data+" entreprises qui ont les mêmes enjeux que vous autour des APIs",
            }
            tile02_en = {
                icon: "../assets/images/tile02.png",
                title: "Network",
                text: "Enrich your network with approximately "+data+" companies that have the same challenges as you around APIs",
            }
        })
	})

    const tile01_fr: TileProps = {
        icon: "../assets/images/tile01.png",
        title: "Gratuit",
        text: "Puisque la qualité n'a pas de prix, être membre du collectif ne vous coûtera rien",
    }
    const tile03_fr: TileProps = {
        icon: "../assets/images/tile03.png",
        title: "Diversité",
        text: "Que vous soyez orienté Business ou IT, vous trouverez forcément dans les chantiers un sujet qui vous passionne !",
    }
    const tile01_en: TileProps = {
        icon: "../assets/images/tile01.png",
        title: "Free",
        text: "Since quality is priceless, being a member of the collective will cost you nothing",
    }

    const tile03_en: TileProps = {
        icon: "../assets/images/tile03.png",
        title: "Diversity",
        text: "Whether you are Business or IT oriented, you are bound to find a subject that fascinates you in construction sites!",
    }

</script>
    
<style lang="scss">

    .homepresentation {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        background-color: $color_white;
        background: linear-gradient(to right, $color_white, $color_grey, $color_white);
        cursor: default;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            padding: 30px 0 30px 0;
            text-align: center;
            color: $color_orange;
        }
        &__subtitle {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            text-align: center;
            color: $color_text;
        }
        &__tiles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin: 0 32px 60px 32px;
        }
    }

    @include large {
        .homepresentation {
            &__tiles {
                display: flex;
                flex-direction: row;
                justify-content: center;
            }
        }
    }

</style>

<div class="homepresentation">
    <div class="bloc homepresentation__bloc">
        <div class="homepresentation__title font__h4">
            {#if ($storeLanguage == $lang_fr)}
            DEPUIS 2020 , LE 1ER COLLECTIF FRANÇAIS DÉDIÉ AUX APIs
            {:else}
            SINCE 2020, THE 1ST FRENCH COLLECTIVE DEDICATED TO APIS
            {/if}                        
        </div>
        <div class="homepresentation__subtitle font__h2">
            {#if ($storeLanguage == $lang_fr)}
            Un collectif qui puise sa force dans ses membres
            {:else}
            A collective that draws its strength from its members
            {/if}
        </div>
        <Line />
        <div class="homepresentation__tiles">
            {#if ($storeLanguage == $lang_fr)}
            <Tile props={tile01_fr}/>
            <Tile props={tile02_fr}/>
            <Tile props={tile03_fr}/>
            {:else}
            <Tile props={tile01_en}/>
            <Tile props={tile02_en}/>
            <Tile props={tile03_en}/>
            {/if}                        
        </div>    
    </div>
</div>
